import { render, staticRenderFns } from "./systemCorporateAccount.vue?vue&type=template&id=61075546&scoped=true&"
import script from "./systemCorporateAccount.vue?vue&type=script&lang=js&"
export * from "./systemCorporateAccount.vue?vue&type=script&lang=js&"
import style0 from "./systemCorporateAccount.vue?vue&type=style&index=0&id=61075546&scoped=true&lang=css&"
import style1 from "./systemCorporateAccount.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61075546",
  null
  
)

export default component.exports